import $http from '@/plugins/axios'
import moment from 'moment'
import SaleService from '@/services/sale.service'

const ProjectService = {
    getProjects (projectType = '') {
        return $http.get('/projects/?project_type=' + projectType)
    },
    createProject (projectName) {
        return $http.post('/projects/', { 'name': projectName })
    },
    handleCreateProjectError (error) {
        if (error.response) {
            if (error.response.status === 429) {
                window.vueapp.$appService.toastError(window.vueapp.$t('modalCreateProject.projectCountExceedLimit'))
            } else if (error.response.data) {
                window.vueapp.$appService.toastError(error.response.data)
            } else {
                window.vueapp.$appService.toastError(window.vueapp.$t('modalCreateProject.createProjectFailed'))
            }
        } else {
            window.vueapp.$appService.toastError(window.vueapp.$t('modalCreateProject.createProjectFailed'))
        }
    },
    getProjectReports (projectId, pageNo, pageSize, fromDate, toDate, serviceName, status, keyword) {
        return $http.get(
            `/projects/${projectId}/request-logs/`,
            {
                params: {
                    'page_size': pageSize,
                    'page': pageNo,
                    'from_date': fromDate,
                    'to_date': toDate,
                    'api_id': serviceName,
                    'status': status,
                    'keyword': keyword
                }
            }
        )
    },
    exportProjectReports (projectId, fromDate, toDate, serviceName, status, email) {
        return $http.post(
            `/projects/${projectId}/export-request-logs/`,
            {
                params: {
                    'from_date': fromDate,
                    'to_date': toDate,
                    'api_id': serviceName,
                    'status': status,
                    'email': email
                }
            }
        )
    },
    getProjectById (projectId) {
        return $http.get(`/projects/${projectId}/`)
    },
    deleteProject (id) {
        return $http.delete('/projects/' + id + '/')
    },
    getPostPaidPackage (filters, pagination) {
        return $http.get('/post-paid-package/?' + SaleService.mapFiltersPackage(filters, pagination))
    },
    getPostPaidPackageMonthlyUsage (packageItem) {
        let startDate = moment(packageItem.start_time).startOf('month')
        let endDate = moment(packageItem.end_time).startOf('month').add(2, 'month')
        let list = []
        while (startDate < endDate) {
            list.push(startDate.valueOf())
            startDate = startDate.add(1, 'month')
        }
        list[0] = moment(packageItem.start_time).valueOf()
        list[list.length - 1] = moment(packageItem.end_time).valueOf() + 86400000 - 1
        let series = ''
        for (let time of list) {
            series += time + ','
        }
        series = series.substring(0, series.length - 1)
        return $http.get('/post-paid-package/' + packageItem.id + '/usage/?series=' + series)
    }
}
export default ProjectService
